import { produce } from 'immer';
import { isEmpty } from 'components/utils';
import request from 'store/common/utils';
import { transfotmDescription } from './transformers';
export const getPublicCompaniesApi = (params) => request({
    url: '/companies/public',
    method: 'GET',
    params,
});
export const getCompaniesApi = (params, signal) => request({
    url: '/companies',
    method: 'GET',
    params,
    signal,
});
export const createCompanyApi = (data) => request({
    url: '/companies',
    method: 'POST',
    data,
});
export const editCompanyApi = (data) => request({
    url: `/companies/${data.id}`,
    method: 'PUT',
    data,
});
export const getCompanyApi = (id) => request({
    url: `/companies/${id}`,
    method: 'GET',
});
export const deleteCompanyApi = (id) => request({
    url: `/companies/${id}`,
    method: 'DELETE',
});
export const getResaleCompaniesApi = () => request({
    url: '/resale/companies',
    method: 'GET',
});
export const getResaleCompanyUnitsApi = (id) => request({
    url: `/resale/companies/${id}`,
    method: 'GET',
});
export const getCompanyResaleUnitsApi = async () => {
    let { data } = await request({
        url: '/company/units',
        method: 'GET',
    });
    data = data.map(produce((item) => {
        if (isEmpty(item.files))
            item.files = { layout: [], documents: [] };
        item.files.documents = (item.files.documents || []).map((doc) => transfotmDescription(doc));
        item.files.layout = (item.files.layout || []).map((lay) => transfotmDescription(lay));
    }));
    return { data };
};
export const downloadCompanyResaleUnitsApi = (data) => request({
    url: '/companies/units/resale/download',
    method: 'POST',
    responseType: 'blob',
    data,
});
export const createUnitApi = (unit) => request({
    url: `/projects/${unit.projectId}/units`,
    method: 'post',
    data: unit,
});
export const updateUnitApi = (unit) => request({
    url: `/projects/${unit.projectId}/units/${unit.id}`,
    method: 'PUT',
    data: unit,
});
export const publishResaleUnitApi = (unit) => request({
    url: `/projects/${unit.projectId}/units/${unit.id}/publish`,
    method: 'POST',
});
export const declineResaleUnitApi = (unit) => request({
    url: `/projects/${unit.projectId}/units/${unit.id}/decline`,
    method: 'POST',
    data: { reason: unit.reason },
});
export const deleteUnitApi = (unit) => request({
    url: `/projects/${unit.projectId}/units/${unit.id}`,
    method: 'DELETE',
});
export const attachLayoutsApi = ({ projectId, data }) => request({
    url: `/projects/${projectId}/unit-layouts`,
    method: 'POST',
    data,
});
export const changeUnitCreatorApi = (data) => request({
    url: '/units/change-creator',
    method: 'POST',
    data,
});
export const regenerateRegistrationTokenApi = (companyId) => request({
    url: `/companies/${companyId}/regenerate-registration-token`,
    method: 'POST',
});
export const validateRegistrationUrlApi = (companyId, token) => request({
    url: `/companies/${companyId}/registration/info?token=${token}`,
    method: 'GET',
});
export const registrationRequestApi = ({ companyId, ...rest }) => request({
    url: `/companies/${companyId}/registration/requests`,
    method: 'POST',
    data: rest,
});
